"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initAllCheckboxPrimary = void 0;
const initAllCheckboxPrimary = () => {
    document.querySelectorAll('.checkbox__wrapper').forEach(($wrapper) => {
        const $input = $wrapper.querySelector('input');
        const showError = () => {
            $wrapper.setAttribute('error-state', '');
            $input.addEventListener('click', () => {
                hideError();
            }, { passive: true, once: true });
        };
        const hideError = () => {
            $wrapper.removeAttribute('error-state');
        };
        $wrapper.showError = showError;
        $wrapper.hideError = hideError;
    });
};
exports.initAllCheckboxPrimary = initAllCheckboxPrimary;
